import styled from 'styled-components';
import { P, fs, radius } from '../theme/tokens';
import { Block } from './Modal/styled';

const Stats = styled.dl`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 0;

  div {
    display: flex;
    flex-direction: column-reverse;
    min-width: 0;
    padding: 10px 11px;
    background: ${P.bgSubtle};
    border: 1px solid ${P.line};
    border-radius: ${radius.md}px;
  }
  dd {
    margin: 0;
    font-size: ${fs.lg}px;
    font-weight: 700;
    line-height: 1.1;
    color: ${P.ink};
    font-variant-numeric: tabular-nums;
    overflow-wrap: anywhere;
  }
  dt {
    margin-top: 4px;
    font-size: 11px;
    color: ${P.subtle};
  }
`;

export default function StatsBlock({ items, label }) {
  return (
    <Block aria-label={label}>
      <Stats>
        {items.map((s) => (
          <div key={s.label}>
            <dt>{s.label}</dt>
            <dd style={s.color ? { color: s.color } : undefined}>{s.value}</dd>
          </div>
        ))}
      </Stats>
    </Block>
  );
}
